export default __webpack_public_path__ + "media/images/grey_close-d4604bb5f2bed43c9465a944224fd2d9.png";